const o = (t) => ({
  wrapper: {
    scrollMarginTop: 70,
    maxWidth: 1200,
    margin: "auto",
    "@media(max-width: 900px)": {
      padding: "48px 0px"
    },
    "@media(max-width: 600px)": {
      padding: "0px 0px"
    }
  },
  sectionTitle: {
    scrollMarginTop: 95,
    color: t.palette.common.blue400,
    fontSize: t.typography.fontSize32,
    lineHeight: 1.6
  },
  card: {
    position: "relative",
    height: "100%",
    boxShadow: "none",
    borderRadius: 16,
    backgroundColor: t.palette.common.blue50,
    minHeight: 306,
    "@media(max-width: 900px)": {
      minHeight: 220
    },
    "@media(max-width: 600px)": {
      minHeight: 160
    }
  },
  bgImg: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    transition: "transform 0.3s ease-in-out",
    transform: "scale(1)",
    transformOrigin: "center center",
    "& img": {
      objectFit: "cover"
    },
    ".MuiPaper-root:hover &": {
      transform: "scale(1.2)"
    }
  },
  overlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(175.54deg, rgba(6, 52, 81, 0.94) 31.87%, rgba(56, 93, 116, 0.376) 96.39%)",
    transition: "background 0.3s ease-in-out",
    ".MuiPaper-root:hover &": {
      background: "linear-gradient(180deg, #063451 34.84%, rgba(56, 93, 116, 0.4) 100%)"
    }
  },
  imgWrapper: {
    height: "100%",
    "& > img": {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  },
  content: {
    position: "relative",
    padding: 24,
    display: "flex",
    flexDirection: "column",
    color: t.palette.common.white,
    "@media(max-width: 600px)": {
      padding: 16
    }
  },
  title: {
    fontSize: t.typography.fontSize22
  },
  subtitle: {
    color: t.palette.common.grey20
  },
  titleWrapper: {
    display: "flex",
    alignItem: "center"
  },
  arrowBtn: {
    minWidth: 24,
    background: "transparent",
    boxShadow: "none",
    marginLeft: 8,
    transform: "translateX(6px)",
    opacity: 0,
    transition: "all 0.3s ease-in-out",
    ".MuiPaper-root:hover &": {
      transform: "translateX(0)",
      opacity: 1
    },
    "&.rtl img": {
      transform: "rotate(180deg)"
    }
  }
}), i = o;
export {
  i as default
};
